import DefaultInstance from "@/instance/axios";
import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from "@lukemorales/query-key-factory";
import {
  DefaultApiWorksOrderGroupFindPostRequest,
  DefaultApiWorksOrderGroupGetRequest,
  DefaultApiWorksOrderGroupOrderSequencePutRequest,
} from "@sizlcorp/sizl-api-document/dist/models";
import dayjs from "dayjs";

export const WORKS_ORDER_GROUPS_KEY = "work_order_groups";

export const worksOrderGroup = createQueryKeys(WORKS_ORDER_GROUPS_KEY, {
  all: null,
  get: (params: DefaultApiWorksOrderGroupGetRequest | any) => {
    const query = { ...params };

    if (params?.query) {
      if (params?.dates) {
        const [beforeDate, afterDate] = params?.dates;

        const before = dayjs(
          dayjs(new Date(beforeDate)).format("YYYY-MM-DD"),
        ).toISOString();

        const after = afterDate
          ? dayjs(afterDate).add(1, "day").subtract(1, "seconds").toISOString()
          : dayjs(before).add(1, "day").subtract(1, "seconds").toISOString();

        const date = after ? [before, after] : [before, before];
        query.query.$and.push({
          createdDay: {
            $between: date,
          },
        });
      }
    }
    if (Array.isArray(params.query?.$and) && params.query?.$and.length > 0) {
      query["query"] = JSON.stringify(params.query);
    }
    if (params.search) {
      query["search"] = params.search;
      query["searchFields"] = params.searchFields;
    }

    return {
      queryKey: [query, JSON.stringify(query.query)],
      queryFn: () => DefaultInstance.worksOrderGroupGet(query),
    };
  },

  find: (params: DefaultApiWorksOrderGroupFindPostRequest | any) => {
    const query = { ...params };
    let targetDateString: string | undefined;
    let targetDateEndString: string | undefined;

    if (params?.query) {
      if (params?.dates) {
        const [beforeDate, afterDate] = params?.dates;

        const before = dayjs(
          dayjs(new Date(beforeDate)).format("YYYY-MM-DD"),
        ).toISOString();

        const after = afterDate
          ? dayjs(afterDate).add(1, "day").subtract(1, "seconds").toISOString()
          : dayjs(before).add(1, "day").subtract(1, "seconds").toISOString();

        const date = after ? [before, after] : [before, before];
        targetDateString = date[0];
        targetDateEndString = date[1];
      }
    }
    if (Array.isArray(params.query?.$and) && params.query?.$and.length > 0) {
      query["query"] = JSON.stringify(params.query);
    }
    if (params.search) {
      query["search"] = params.search;
      query["searchFields"] = params.searchFields;
    }

    return {
      queryKey: [
        query,
        targetDateString,
        targetDateEndString,
        JSON.stringify(query.query),
      ],
      queryFn: () =>
        DefaultInstance.worksOrderGroupsFindPost(query, {
          params: {
            targetDateString,
            targetDateEndString,
          },
        }),
    };
  },
});

export const mutateWorksOrderGroup = createMutationKeys(
  WORKS_ORDER_GROUPS_KEY,
  {
    order: (params: DefaultApiWorksOrderGroupOrderSequencePutRequest) => ({
      mutationKey: [params],
      mutationFn: () => DefaultInstance.worksOrderGroupOrderSequencePut(params),
    }),
  },
);

export const defectQueryKeys = mergeQueryKeys(
  worksOrderGroup,
  mutateWorksOrderGroup,
);
